import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestMedicalsViewDto } from '../dto/medicals.dto';

@Injectable()
export class MedicalsNestApi {

  private service: string = '';
  private model: string = 'Medicals';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public view(payload: RequestMedicalsViewDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'view';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/medicals.api.ts